import { ArrowRight, PhoneCall } from "lucide-react";
import { CONTACT } from "../lib/constants";

export const CtaBand = () => {
  const goContact = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="cta-band"
      className="relative bg-[#0B2545] py-20 md:py-24 overflow-hidden grain"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-20 -right-20 w-96 h-96 border border-[#C8A24A]/20 rotate-12" />
        <div className="absolute -bottom-32 -left-20 w-[28rem] h-[28rem] border border-[#C8A24A]/15 rotate-45" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10 items-center">
        <div className="reveal">
          <div className="flex items-center gap-4 mb-6">
            <span className="gold-line" />
            <span className="font-sans text-[#C8A24A] uppercase text-xs tracking-widest-2">
              Plan a Consignment
            </span>
          </div>
          <h2 className="font-serif text-white text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            Cargo doesn't wait.{" "}
            <em className="not-italic text-[#C8A24A]">Neither do we.</em>
          </h2>
        </div>
        <div className="reveal flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4 justify-end" style={{ transitionDelay: "120ms" }}>
          <button
            data-testid="cta-band-quote"
            onClick={goContact}
            className="group inline-flex items-center justify-center gap-3 bg-[#C8A24A] text-[#0B2545] font-bold px-8 py-4 uppercase text-sm tracking-widest-2 hover:bg-[#D4AF37] transition-colors"
          >
            Request a Quote
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            data-testid="cta-band-call"
            href={`tel:${CONTACT.phones[0].replace(/\s/g, "")}`}
            className="inline-flex items-center justify-center gap-3 border border-[#C8A24A] text-[#C8A24A] hover:bg-[#C8A24A] hover:text-[#0B2545] font-bold px-8 py-4 uppercase text-sm tracking-widest-2 transition-colors"
          >
            <PhoneCall size={16} /> Call {CONTACT.phones[0]}
          </a>
        </div>
      </div>
    </section>
  );
};
